import { render } from "./AppTemplates.vue?vue&type=template&id=5464a7cb&scoped=true"
import script from "./AppTemplates.vue?vue&type=script&lang=js"
export * from "./AppTemplates.vue?vue&type=script&lang=js"

import "./AppTemplates.vue?vue&type=style&index=0&id=5464a7cb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5464a7cb"]])

export default __exports__